/*=====================================
    快速下單選項 component

    有三種 layoutType
    no-dropdown： 全部列出來
    only-dopdown： 只用dropdown列出
    default： 會依造overCount來顯示，如果列表數大於overCount，則多的會用dropdown顯示

    Author: Gray
    CreateTime: 2018 / 11 / 29
=====================================*/
window.InifECApp.directive('quicklySpecOptions', ['$rootScope', function($rootScope) {

    var _dir = {};

    var controller = ['$scope', function($scope) {

        // ------------------------------
        // isOptionActive
        // ------------------------------
        var isOptionActive = function(option) {

            if($scope.isActive) {
                return $scope.isActive(option, $scope.value);
            }
            

            return option === $scope.value;
        }

        // ------------------------------
        // getOptionString
        // ------------------------------
        var getOptionString = function(option) {

            if($scope.getString) {
                return $scope.getString(option);
            }
            

            return option;
        }

        // ------------------------------
        // getOptionHtmlString
        // ------------------------------
        var getOptionHtmlString = function(option) {

            if($scope.getHtmlString) {
                return $scope.getHtmlString(option);
            }
            

            return '<span>' + option + '</span>';
        }

        // ------------------------------
        // onOptionsClick
        // ------------------------------
        var onOptionsClick = function(option, isMoreMenu) {

            var active = isOptionActive(option);
            var key = $scope.key;

            $scope.isMoreMenu = !!isMoreMenu;

            $scope.onChange && $scope.onChange(option, active, key);
        }

        // ------------------------------
        // Init
        // ------------------------------
        var init = function() {

            if(!$scope.layoutType) {
                $scope.layoutType = "default";
            }

            if(!$scope.overCount) {
                $scope.overCount = 10;
            }

            if(!$scope.isOptional) {
                $scope.isOptional = false;
            }

            if($scope.onMouseEnter) {
                $scope.onOptionsMouseEnter = $scope.onMouseEnter;
            }

            if($scope.isFirstUndefined) {
                $scope.optionsList.push(undefined);
            }

            for(var i = 0; i < $scope.options.length; i++) {
                $scope.optionsList.push($scope.options[i]);
            }

            var length = $scope.optionsList.length;
            var isOnlyOne = length === 1;
            var isOver = length > $scope.overCount;
            var showType = 1;

            if(isOnlyOne && !$scope.isOptional) {
                // only item
                showType = 3;
            } else {
                switch($scope.layoutType) {
                    case "no-dropdown":
                        // no-dropdown
                        showType = 4;
                        break;
                    case "only-dropdown":
                        showType = 5;
                        break;
                    case "color-list":
                        showType = 6;
                        break;
                    case "process-list":
                        showType = 7;
                        break;
                    case "default":
                    default:
                        if(isOver) {
                            showType = 2;
                            // 檢查是不是在more裡面
                            for(var i = $scope.overCount - 1; i < length; i++) {
                                var option = $scope.optionsList[i];
                                if($scope.isOptionActive(option)) {
                                    $scope.isMoreMenu = true;
                                    break;
                                }
                            }
                        } else {
                            showType = 1;
                        }
                        break;
                }
            }

            $scope.showType = showType;
            $scope.hasHtml = !!$scope.getHtmlString;
        }

        /*--------------------------
            Variable
        --------------------------*/
        $scope.showType = 1; // 1 列表, 2 列表＋選單, 3 純顯示, 4 純列表, 5 純選單, 6 顏色列表, 7 加工列表
        $scope.hasHtml = false;
        $scope.isMoreMenu = false;
        $scope.optionsList = [];

        /*--------------------------
            Method
        --------------------------*/
        $scope.isOptionActive = isOptionActive;
        $scope.getOptionString = getOptionString;
        $scope.getOptionHtmlString = getOptionHtmlString;
        $scope.onOptionsClick = onOptionsClick;
        $scope.onOptionsMouseEnter;

        init();
    }];

    _dir.restrict = 'E';
    _dir.scope = {
        key: '=',
        value: '=',
        options: '=',
        layoutType: '=',
        overCount: '=',
        isOptional: '=',
        isFirstUndefined: '=',
        specSelectClass: '=',
        isOnlyDropdownNoActive: '=',
        isProcessRadio: '=',
        isActive: '=',
        getString: '=',
        getHtmlString: '=',
        onChange: '=',
        onMouseEnter: '=',
    };
    _dir.replace = true;
    _dir.templateUrl = "partials/directives/quickly_spec_options.html";
    _dir.controller = controller;

    return _dir;
}]);